import config from '../config/configureEnv';
import { ajax, getUserAuthDataFromLocalStorage } from '../utils';

export default {
  getLocation: (zipcode) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('GET', `${config.bocaAPIUrl}/location/${zipcode}`, {
      urlParams: { access_token: accessToken },
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/GetZipcodeInfo.js